function VendorDownload(): React.ReactElement {
  return (
    <></>
  );
}

export default VendorDownload;
